import Repository from './Repository'

const action = 'clients'

export default {
  /** Tasks **/
  getList(settings = {}) {
    let params = ''

    for (let key in settings) {
      if (settings[key] || settings[key] === 0) {
        params += params ? '&' : '?'
        params += `${key}=${settings[key]}`
      }
    }

    return Repository.get(action + params)
  },
  getItem(id) {
    return Repository.get(`${action}/${id}`)
  },
  postItem(data) {
    return Repository.post(action, data)
  },
  updateItem(id, data) {
    return Repository.post(`${action}/${id}`, data)
  },
  deleteItem(id) {
    return Repository.delete(`${action}/${id}`)
  },
}
